<cmps-wait-status *ngIf="state?.pending?.data"></cmps-wait-status>

<div
    class="container-fluid insight-visual"
    *ngIf="!state?.pending?.data && layoutQuery.vils"
>
    <div class="row">
        <ng-container *ngFor="let i of view?.pillars; let ii = index">
            <div
                class="col"
                [ngStyle]="layoutQuery.vils[0].children[ii].styleObj"
            >
                <div class="row">
                    <div class="col-12">
                        <div
                            class="insight-pillar"
                            data-pillar
                            *ngIf="i.displayHeader"
                        >
                            {{ i.name }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <ng-container *ngIf="!i.pillars || i.pillars.length === 0">
                        <div class="col">
                            <div
                                class="insight-child-pillar"
                                *ngIf="layoutQuery.otherHaveChildren"
                            >
                                &nbsp;
                            </div>
                            <ng-container
                                *ngTemplateOutlet="
                                    groupTpl;
                                    context: {
                                        p: i,
                                        v: layoutQuery.vils[0].children[ii]
                                    }
                                "
                            ></ng-container>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="i.pillars && i.pillars.length !== 0">
                        <ng-container
                            *ngFor="let j of i.pillars; let jj = index"
                        >
                            <div
                                class="col"
                                [ngStyle]="
                                    layoutQuery.vils[0].children[ii].children[
                                        jj
                                    ].styleObj
                                "
                            >
                                <div
                                    class="insight-child-pillar"
                                    data-pillar
                                    data-child-pillar
                                    *ngIf="j.displayHeader"
                                >
                                    {{ j.name }}
                                </div>
                                <ng-container
                                    *ngTemplateOutlet="
                                        groupTpl;
                                        context: {
                                            p: j,
                                            v: layoutQuery.vils[0].children[ii]
                                                .children[jj]
                                        }
                                    "
                                ></ng-container>
                            </div>
                            <div
                                class="insight-child-pillar-separator"
                                *ngIf="
                                    jj <
                                    layoutQuery.vils[0].children[ii].layout
                                        .itemsPerRow -
                                        1
                                "
                            ></div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div
                class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 insight-pillar-separator"
                *ngIf="ii < layoutQuery.vils[0].layout.itemsPerRow - 1"
            ></div>
        </ng-container>
    </div>
</div>

<ng-template
    #groupTpl
    let-p="p"
    let-v="v"
>
    <div
        cmpsInsightVisualItem
        [pillar]="p"
        [metrics]="metrics"
        [data]="state?.data"
        [peerGroupData]="view?.showPeerGroupVisual && state?.peerGroupData"
        [showThresholdColours]="view.showThresholdColours"
        [showTrendArrows]="view.showTrendArrows"
        [optionalColumns]="optionalColumns"
        (itemClick)="onItemClick($event)"
        [vil]="v"
    ></div>
</ng-template>
